module.exports = __webpack_public_path__ + "static/img/ls29.8e0c0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls29.png
// module id = aUdc
// module chunks = 12